<template>
    <div>
        <div class="TabButtonBox">
            <div class="TabButton" :class="{SelectedItem : this.showRicambi}" @click="this.mostraTab('ricambi')">Ricambi</div>
            <div class="TabButton" :class="{SelectedItem : this.showCosti}"  @click="this.mostraTab('costi')">Costi</div>
        </div>
        <div class="TabContentBox">
            <div class="TabContent" :id="'tabRicambiGest' + this.indexIntervento"> 
                <div class="TabellaOperazioniRicambi">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                            <tr>
                            <th scope="col">Codice ricambio</th>
                            <th scope="col">Descrizione ricambio</th>
                            <th scope="col">Unità di misura</th>
                            <th scope="col">Quantità</th>
                            <th scope="col">Magazzino</th>
                            <th scope="col">Entità</th>
                            <th scope="col">Attività</th>
                            </tr>
                            <tr v-for="(ricambio, index) in this.listaRicambi" :key="index">
                                <td><span>Codice ricambio</span>{{ ricambio.CodiceArticolo }}</td>
                                <td><span>Descrizione ricambio</span>{{ ricambio.DescrizioneArticolo }}</td>
                                <td><span>Unità di misura</span>{{ ricambio.UnitaMisura }}</td>
                                <td><span>Quantità</span>{{ ricambio.QtaEffettiva }}</td>
                                <td><span>Magazzino</span>{{this.$store.getters.getDescrMagazzino(ricambio.CodiceMagazzino)}}</td>
                                <td><span>Entità</span>{{ricambio.DescrizioneEntita}}</td>
                                <td><span>Attività</span>{{ricambio.DescrizioneAttivita}}</td>
                            </tr>            
                        </tbody>
                    </table>
                </div> 
            </div>           
            <div class="TabContent" style="display:none;" :id="'tabCostiGest' + this.indexIntervento" >        
                <div class="TabellaOperazioniRicambi">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0">
                    <tbody>
                        <tr>
                        <th scope="col">Descrizione costo</th>
                        <th scope="col">Unità</th>
                        <th scope="col">Costo Unitario</th>
                        <th scope="col">Q.tà Prevista</th>
                        <th scope="col">Q.tà Effettiva</th>
                        <th scope="col">Incluso</th>
                        <th scope="col" class="TORImp">Importo</th>                       
                        <th scope="col" class="TORCon">Nr. Contratto</th>
                        </tr>
                        <!-- Inizio repeater repeater -->
                        <tr v-for="(costo, index) in this.listaCosti.Costi" :key="index">
                        <td><span>Descrizione costo</span>{{ costo.DescrizioneCosto }}</td>
                        <td><span>Unità</span> {{ costo.UnitaMisura }}</td>
                        <td><span>Costo Unitario</span>{{this.number_format(costo.CostoUnitario, 2, ',', '.')}} {{this.listaCosti.Valuta}}</td>
                        <td><span>Q.tà Prevista</span>{{ costo.QtaPrevista }}</td>
                        <td><span>Q.tà Effettiva</span> {{ costo.QtaEffettiva }}</td>
                        <td class="TORChe">
                            <span>Incluso</span><i class="CheckIcon" v-show="costo.Incluso ? true : false"><img src="/App_Skins/Sito/images/CheckIcon.png" srcset="/App_Skins/Sito/images/CheckIconRetina.png 2x" alt=""/></i>
                        </td>
                        <td class="TORImp"><span>Importo</span>{{this.number_format(costo.Importo ?? 0, 2, ',', '.')}} {{this.listaCosti.Valuta}}</td>
                        <td class="TORCon">
                            <span>Nr. Contratto</span>{{ costo.NrContratto }}
                        </td>
                        </tr>
                        <!-- Fine repeater repeater -->                     

                        <!-- Inizio riga costi -->
                        <tr>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td class="TORTot" colspan="2">
                            <div class="Total">
                            <span>Importo Totale:</span> <strong>{{this.number_format(this.listaCosti.ImportoTotale, 2, ',', '.')}} {{this.listaCosti.Valuta}}</strong>
                            </div>
                        </td>
                        <td>&nbsp;</td>
                        </tr>
                        <!-- Fine riga costi -->
                    </tbody>
                    </table>
                </div>                
            </div>
        </div>
        <div class="DetailSendingBox">
            <div class="DetailSendingButton">
                <a @click="this.openPopUpGestione()" href="javascript:void(0)">Segnala come Gestito</a>
            </div>
        </div>
    </div>
    <GestioneInterventoModal
    :intervento="this.intervento"
    v-model="this.showModal"
    ></GestioneInterventoModal>
</template>

<script>

import RicambioAttivita from "@/models/ricambioAttivita.model.js";
import CostoIntervento from "@/models/costoIntervento.model.js";
import GestioneInterventoModal from "@/components/modals/GestioneInterventoModal.vue";
import {apiMixin, numberMixin} from "/mixin.js";

export default {
    name: "PannGestInterventiInCorso",
    data(){
        return {
            showRicambi: true,
            showCosti: false,
            showModal: false,
            listaCosti: {
                Costi: []
            },
            listaRicambi: [],
            totaleCosti: 0
        }
    },
    components:{
        GestioneInterventoModal
    },
    props: {
        intervento: Object,
        indexIntervento: Number
    },  
    mixins: [apiMixin, numberMixin],
    methods: {
        mostraTab: function(tipoTab){            

            if(tipoTab == "ricambi"){
                this.showRicambi = true;
                this.showCosti = false;
                $("#tabRicambiGest" + this.indexIntervento).fadeIn('fast');
                $("#tabCostiGest" + this.indexIntervento).fadeOut(0);
            }
            if(tipoTab == "costi"){

                let params = {
                    CodiceIntervento: this.intervento.CodiceIntervento
                };

                this.doApiCall("get", "interventi/GetCostiIntervento", this.$store.getters.getUtente.Token, params).then(

                (data) => {                
                    if(data){
                        this.listaCosti = Object.assign(new CostoIntervento(), data)                                             
                        this.showRicambi = false;
                        this.showCosti = true;
                        $("#tabCostiGest" + this.indexIntervento).fadeIn('fast');
                        $("#tabRicambiGest" + this.indexIntervento).fadeOut(0);                                                
                    }             
                }); 
            }
        },
        openPopUpGestione: function(){
            this.showModal = true;
        }       
    },
    created(){ 
        let params = {
            CodiceIntervento: this.intervento.CodiceIntervento
        };
        this.listaMagazzini = this.$store.getters.getMagazzini;
        this.doApiCall("get", "interventi/GetRicambiIntervento", this.$store.getters.getUtente.Token, params).then(

        (data) => {                
            if(data){
                this.listaRicambi = data.map(o => {
                    return Object.assign(new RicambioAttivita(), o)
                }).filter(item =>{
                    return item.QtaEffettiva > 0;
                }); 
            }             
        });
    },

}
</script>